<template>
    <router-view></router-view>

  <LoadingComp ref="loading"></LoadingComp>
  <BasicModalComp ref="basicModal"></BasicModalComp>
</template>

<script>
import LoadingComp from '@/CommonVueCore/src/components/baseComponents/LoadingComp.vue';
import BasicModalComp from '@/CommonVueCore/src/components/baseComponents/modalComponents/basicModal.vue';
// import sweetAlertService from '@/CommonVueCore/src/services/sweetAlert2Service/sweetAlert2Service';
import { checkVersion } from '@/CommonVueCore/src/services/version/version-checker';

export default {
  name: 'App',
  components: {
    LoadingComp,
    BasicModalComp
  },
  inject: ['sweetAlertService', "sweetToastrService"],
  mounted() {
    this.$root.loading = this.$refs.loading;
    this.$root.basicModal = this.$refs.basicModal;
    // sweetAlertService.info('deneme', 'test info')
    // this.sweetToastrService.success('başarılı');


    // this.ali.veli = 2;

    // Promise.reject(new Error("Bu bir test hatasıdır!"));
  },
  created() {
    setInterval(async () => {
      const hasNewVersion = await checkVersion();
      if (hasNewVersion) {
        // alert('Yeni bir güncelleme mevcut! Sayfa yenileniyor...');
        this.sweetAlertService.info('A new update is available. The page will refresh...').then(() => {
          // window.location.reload();
          location.reload();
        });
      }
    }, 60000);
  },
}
</script>

<style>
[data-floating-menu="true"] {
  display: block;
  background-color: #fff;
  border-radius: .375rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, .12), 0 2px 6px rgba(15, 23, 42, .08);
  padding: .25rem 0;
}

.floating-menu-enter-active,
.floating-menu-leave-active {
  transition: opacity .12s ease, transform .12s ease;
  transform-origin: top right;
}
.floating-menu-enter-from,
.floating-menu-leave-to {
  opacity: 0;
  transform: scale(.97) translateY(-2px);
}
</style>
